<div class="nes-flex nes-flex-col nes-items-center nes-w-full">
  <p
    class="nes-text-inverse-subdued nes-mb-8 nes-m-y-0 nes-max-w-prose nes-text-center"
  >
    {{ "ADVICE.FOOTER.TEXT" | translate }}
  </p>
  @if (isMobileView) {
    <nes-button
      (nesOnClick)="orderProduct.emit(advicedProduct.name)"
      class=""
      variant="brand"
    >
      {{
        "ADVICE.FOOTER.MOBILE_BUTTON_TEXT." + advicedProduct.name.toUpperCase()
          | translate
      }}
    </nes-button>
  } @else {
    <nes-button
      (nesOnClick)="orderProduct.emit(advicedProduct.name)"
      class=""
      variant="brand"
    >
      {{
        "ADVICE.FOOTER.BUTTON_TEXT." + advicedProduct.name.toUpperCase()
          | translate
      }}
    </nes-button>
  }
</div>
